import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

import { Language } from '../../interfaces/Language';
import { TranslationManagerService } from '../../services/translation-manager/translation-manager.service';
import { SUPPORTED_LANGUAGES } from '../../utils/constants';

@Component({
  selector: 'frodo-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {
  @ViewChild('trigger') triggerEl!: ElementRef<HTMLButtonElement>;

  languages: Language[] = [];
  selectedlanguage: string;
  open = false;

  constructor(
    private languageService: TranslationManagerService,
    private hostEl: ElementRef<HTMLElement>
  ) {
    this.selectedlanguage = languageService.language;
  }

  ngOnInit(): void {
    this.populateLanguages();
  }

  populateLanguages(): void {
    this.languages = SUPPORTED_LANGUAGES.filter((language: Language) =>
      this.languageService.selectableLanguages.includes(language.code)
    );
  }

  toggle(): void {
    this.open = !this.open;
  }

  close(): void {
    this.open = false;
  }

  onlanguageChange(languageCode: string): void {
    this.selectedlanguage = languageCode;
    this.languageService.updateTranslations(languageCode);
    this.close();
  }

  get selectedlanguageData(): Language | undefined {
    return SUPPORTED_LANGUAGES.find(
      (language: Language) => this.selectedlanguage === language.code
    );
  }

  @HostListener('document:pointerdown', ['$event'])
  onPointerDownOutside(event: PointerEvent): void {
    if (!this.open) return;

    const target = event.target as Node;
    if (!target) return;

    if (this.hostEl.nativeElement.contains(target)) return;

    this.close();
  }

  @HostListener('keydown.escape')
  onEscape(): void {
    if (!this.open) return;

    this.close();
    this.triggerEl.nativeElement.focus();
  }

  @HostListener('focusout', ['$event'])
  onFocusOut(event: FocusEvent): void {
    if (!this.open) return;

    const nextTarget = event.relatedTarget as Node | null;
    if (nextTarget && this.hostEl.nativeElement.contains(nextTarget)) return;

    this.close();
  }
}
